import { toast } from "react-toastify";
import axiosConfig from "../axiosConfig.js";

class ExplorerService {
    getPost = async (take, page, type ) => {
        try {
            const response = await axiosConfig.get(`explorer/getPosts?take=${take}&page=${page}&PostType=${type}`);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Explorer Provider not get"; // Fallback message
            // Show the error message as a toast notification
            // Re-throw the error for further handling if needed
            toast.error(error?.message);
            // throw new Error(error);
        }
    };
    getPostDetails = async (postId) => {
        try {
            const response = await axiosConfig.get(`explorer/getPostDetails?postId=${postId}`);
            return response;
        } catch (error) {
            const errorMessage = error?.message || "Explorer Provider not get"; // Fallback message
            // Show the error message as a toast notification
            // Re-throw the error for further handling if needed
            toast.error(error?.message);
            // throw new Error(error);
        }
    };
    
}

const instance = new ExplorerService();

export default instance;
